export default {
  fromStore(createdTasks, ganttInstance) {
    ganttInstance.batchUpdate(() => {
      createdTasks.forEach(createdTask => {
        const { sourceTaskId, targetTaskId } = createdTask;

        if (!ganttInstance.isTaskExists(sourceTaskId)) {
          return;
        }

        ganttInstance.silent(() => {
          ganttInstance.changeTaskId(sourceTaskId, targetTaskId);
        });
      });
    });
  },

  fromGantt() {

  },
};
